import React, {useRef} from 'react';
import {motion, useInView} from 'framer-motion';

import BlogCard from './BlogCard';

import {BLOG_CARD_URL_01} from '../../config/urls';
import {BLOG_CARD_URL_02} from '../../config/urls';
import {useMediaQuery} from '../../hooks/useMediaQuery';
import styles from './styles/main-03.module.css';

import {ReactComponent as Thumbnail01} from '../../assets/main03/thumbnail-01.svg';
import {ReactComponent as Thumbnail02} from '../../assets/main03/thumbnail-02.svg';

const easeInMotion = {
  ease: 'easeIn',
  duration: 0.8
};

const blogCardMotion = {
  hidden: { y: 100, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      mass: 1,      
      stiffness: 80,
      damping: 15,
      delay: 0.8
    }
  }
};

export default function Main03() {
  const mobile = useMediaQuery('(max-width: 768px)');
  const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');

  const ref = useRef(null);
      
  const isInView = useInView(ref, {
    once: true,
    amount: mobile ? 0.1 : 0.2,
    margin: mobileMedium ? '-20px 0px' : '-100px 0px'
  });

  return (
    <div className={styles.wrapper}>
       <div className={styles.container} ref={ref}>
        <motion.p
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : { opacity: 0 }}
          transition={easeInMotion}
        >
          {mobile 
            ? <>일의 흐름,<br />DARVIS가 바꾸고 있어요</>
            : '일의 흐름, DARVIS가 바꾸고 있어요'
          }
        </motion.p>
        <motion.div
          initial='hidden'
          animate={isInView ? 'visible' : 'hidden'}
          variants={blogCardMotion}
        >
            <BlogCard
                Thumbnail={Thumbnail01}
                title='비즈니스PT'
                content='60개 넘는 내부 문서를 직접 검색할 필요가 없어졌어요.'    
                link={BLOG_CARD_URL_01}
            />
            <BlogCard
                Thumbnail={Thumbnail02}
                title='우진공업(주)'
                content='다비스를 만나고 데이터 활용에 극강의 효율을 경험했습니다.'   
                link={BLOG_CARD_URL_02}
            />
        </motion.div>
       </div>
    </div>
  );
}
